import { type AlertsState } from './types';

const initialAlertsState: AlertsState = {
  items: [],
};

export { initialAlertsState };
